<span
  [ngClass]="suffix.className"
  [style.color]="suffix.color"
  [style.backgroundColor]="suffix.backgroundColor"
  [style.borderColor]="suffix.borderColor"
  >{{ suffix.title }}</span
>
